import { FC, useState, createContext, ReactNode } from 'react';

type ISidebarContext = {
  title: string;
  sidebarToggle: any;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  defineTitle: (input: string) => void;
  fixedExpanded: boolean;
  setFixedExpanded: (input: boolean) => void;
};

export const SidebarContext = createContext<ISidebarContext>(
  {} as ISidebarContext
);

export const SidebarProvider: FC<{children: ReactNode}> = ({ children }) => {

  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [fixedExpanded, setFixedExpanded] = useState(false);

  const [title, setTitle] = useState('greetings!');

  const defineTitle = (input: string) => {
    setTitle(input);
  }

  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  }

  const closeSidebar = () => {
    setSidebarToggle(false);
  }

  return (
    <SidebarContext.Provider
      value={{
        title,
        sidebarToggle,
        toggleSidebar,
        closeSidebar,
        defineTitle,
        fixedExpanded,
        setFixedExpanded
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
